// extracted by mini-css-extract-plugin
export default {"statistics_overview":"overview_statistics_overview__K9Hni","statistics":"overview_statistics__LXAn1","statistics_card":"overview_statistics_card__gW6ho"};